import { Form, Button, Input, InputNumber, Select, Typography, Space, Tooltip, Switch, Card, Row, Col } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useState } from "react";

const { Title, Paragraph, Text } = Typography;
const { Option } = Select;
const TaxAndRegulatoryForm = ({ form, updateFormData, onFinish, contractTemplate }) => {
  const [withHoldingTax, setWithHoldingTax] = useState(false);
  const [KYCKYBValidated, setKYCKYBValidated] = useState();
  const [centralBankAuctionReferenceLinked, setCentralBankAuctionReferenceLinked] = useState();
  console.log(contractTemplate);
  return (
    <div className="form-section">
      <h2 style={{ fontSize: "24px", margin: 0 }}>Tax & Regulatory</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>Add description text to note for users</p>

      <Form form={form} onFinish={onFinish} layout="vertical" style={{ width: "100%" }}>
        {/* === Inputs Row === */}
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Code cannot be empty",
                },
                {
                  pattern: /^[A-Z0-9]+$/,
                  message: "Code must contain only uppercase letters, numbers and less than 5 characters",
                },
                // {
                //   max: 5,
                //   message: "Code must be less than 5 characters",
                // },
              ]}
              label={
                <Space>
                  Central Bank Reporting Code
                  <Tooltip title="Central Bank Reporting Code">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"centralBankReportingCode"}
            >
              <Input placeholder="TB282" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label={
                <Space>
                  AML Flag
                  <Tooltip title="AML Flag">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              rules={[
                {
                  required: true,
                  message: "Please select AML Screening",
                },
              ]}
              name={"amlScreening"}
            >
              <Select options={contractTemplate.amlOptions} placeholder="Cleared" style={{ height: 44 }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col
            span={12}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          >
            <Form.Item name={"withholdTax"} style={{ margin: 0, padding: 0 }} valuePropName="checked">
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>Withholding Tax</Text>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          />
          <Col
            span={12}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          >
            <Form.Item name={"kycValidated"} style={{ margin: 0, padding: 0 }} valuePropName="checked">
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>KYC/KYB Validated</Text>
          </Col>

          <Col
            span={12}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          />
          <Col
            span={12}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          >
            <Form.Item name={"centralBankAuctionRefLinked"} style={{ margin: 0, padding: 0 }} valuePropName="checked">
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>Central Bank Auction Reference Linked</Text>
          </Col>
          {/* <Col xs={24} sm={24}>
            <Form.Item colon={false} labelCol={{ span: 16 }} wrapperCol={{ span: 8 }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <Switch checked={withHoldingTax} onChange={(checked) => setWithHoldingTax(checked)} />
                <span>Withholding Tax</span>
              </div>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item colon={false} labelCol={{ span: 16 }} wrapperCol={{ span: 8 }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <Switch checked={KYCKYBValidated} onChange={(checked) => setKYCKYBValidated(checked)} />
                <span>KYC/KYB Validated</span>
              </div>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item colon={false}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Switch checked={centralBankAuctionReferenceLinked} onChange={(checked) => setCentralBankAuctionReferenceLinked(checked)} />
                <div>Central Bank Auction Reference Linked</div>
              </div>
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default TaxAndRegulatoryForm;
